import { render, staticRenderFns } from "./e2-container-full.vue?vue&type=template&id=0bfa6a2a"
import script from "./e2-container-full.vue?vue&type=script&lang=js"
export * from "./e2-container-full.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports